import { FaIcons } from "@in/component-library";
import React, { FC, SyntheticEvent } from "react";
import { useLayout } from "../../hooks/use-layout";
import ActionTool from "../action-tool/action-tool";

interface CloseApplicationToolProps {
  handleClose: (e: SyntheticEvent) => void;
}

const CloseApplicationTool: FC<CloseApplicationToolProps> = ({ handleClose }) => {
  const { translations } = useLayout();

  return (
    <ActionTool
      onClick={handleClose}
      iconName={FaIcons.TimesLight}
      label={translations.close}
      ariaLabel={`${translations.close}`}
    />
  );
};

export default CloseApplicationTool;
